<template>
  <v-app-bar
      app
      color="white"
      class="header-nav"
  >

    <v-app-bar-nav-icon
        v-if="isLogin"
        @click="drawerEmit(0)"
        class="hidden-lg-and-up header-drawer-icon"
    ></v-app-bar-nav-icon>

    <v-spacer></v-spacer>

    <div v-if="isLogin" class="lack--text text-left">
      <div class="font-weight-bold">{{ companyName }}（{{ companyCode }}）</div>
      <div>{{ username }}（{{ userCode }}）</div>
    </div>

    <v-divider
        vertical
        inset
        class="ml-5"
    ></v-divider>

    <v-toolbar-items v-if="isLogin">
      <v-menu offset-y>
        <template v-slot:activator="{on}">
          <v-btn v-on="on" class="" v-if="isLogin" icon>
            <v-icon>mdi-exit-to-app</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item @click.stop="logout" link>
            <v-list-item-content>
              <v-list-item-title>
                ログアウト
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-toolbar-items>
  </v-app-bar>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  props: {
    drawerLeft: {
      type: Boolean
    },
    drawerRight: {
      type: Boolean
    }
  },
  computed: {
    ...mapGetters ({
      isLogin: 'auth/check',
      username: 'auth/name',
      userCode: 'auth/user_code',
      companyName: 'auth/company_name',
      companyCode: 'auth/company_code',
    }),
    computedDrawerLeft: {
      get() {
        return this.drawerLeft
      },
      set(drawer) {
        this.$emit('input', drawer)
      }
    },
    computedDrawerRight: {
      get() {
        return this.drawerRight
      },
      set(drawer) {
        this.$emit('input', drawer)
      }
    }
  },
  methods: {
    async logout() {
      await this.$store.dispatch('auth/logout')
      await this.$router.push('/login')
    },

    drawerEmit(type) {
      this.$emit('drawerClick', !this.drawerLeft, type);
    }
  }
}
</script>